
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadOrders, loadSpecies, loadReport, loadPurchaseOrder, loadGlobalStatus } from '../utilities/httpRequest';
import { specieNameFromId } from "../utilities/utils";
import ImageRoundButton from '../components/ImageRoundButton';
import classNames from 'classnames';
import {ClipboardPlus,ListPlus,Check,X} from 'lucide-react';
import {Address,Pet,PetOwner} from '../utilities/dataUtils';

export default function ContentDemand() {

    const navigate = useNavigate();

    const [orders, setOrders] = useState({
        count: 0,
        next: null,
        previous: null,
        results: []
    });

    const [orderParam, setOrderParam] = useState({
        page: 1,
        per_page: 25,
        isPrescriber: null,
        search: null,
        specie: null,
        global_status: null
    });

    const [species, setSpecies] = useState([]);

    useEffect(() => { loadOrders(navigate, setOrders, orderParam) }, [orderParam, navigate]);
    useEffect(() => { loadSpecies(setSpecies, navigate) }, [navigate]);

    return (
        <div className="h-full p-5 overflow-hidden">
            <div className="h-full bg-medium-green max-h-full pb-5 pt-3 overflow-hidden flex flex-col shadow-sym rounded-2xl">
                <div className="flex justify-between">
                    <h1 className="text-white px-5">Mes dossiers</h1>
                    <div className="flex flex-col items-end justify-between pr-5 gap-2">
                        <PageFilter orderParam={orderParam} setOrderParam={setOrderParam} next={orders.next} previous={orders.previous} count={orders.results.length} />
                        <div className="flex flex-row text-sm gap-8 mb-2">
                            <PrescriberFilter setOrderParam={setOrderParam} />
                            <SearchFilter setSearchValue={(e) => setOrderParam((prevData) => ({ ...prevData, search: e }))} />
                            <SpecieFilter species={species} setId={(e) => setOrderParam((prevData) => ({ ...prevData, specie: e }))} />
                            <StatusFilter navigate={navigate} setStat={(e) => setOrderParam((prevData) => ({ ...prevData, global_status: e }))} />
                        </div>
                    </div>
                </div>
                <div className="h-full overflow-y-auto">
                    <table className="w-full text-dark-green border-collapse">
                        <thead>
                            <tr className="bg-light-green text-white h-10">
                                <th className="w-10 font-medium"></th>
                                <th className="min-w-24 font-medium text-left">Propiétaire</th>
                                <th className="min-w-20 font-medium text-left">Animal</th>
                                <th className="min-w-20 font-medium text-left">Nom</th>
                                <th className="min-w-20 font-medium text-center">Statut de demande</th>
                                <th className="min-w-24 font-medium text-center">Statut comptable</th>
                                <th className="min-w-24 font-medium text-center">Date de demande</th>
                                <th className="min-w-16 font-medium text-center">Echantillon(s) reçu(s)</th>
                                <th className="min-w-16 font-medium text-center">Ajout d'analyses</th>
                                <th className="min-w-16 font-medium text-center">Nouvelle prescription</th>
                                <th className="min-w-28 font-medium text-center">Documents</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.results.map((item) => <FillRow key={item.id} item={item} species={species} navigate={navigate} />)}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    );
}
function FillRow({ item, species, navigate }) {

    let style = {}
    if (item.global_status.color !== "" && item.global_status.color !== null) {
        style = { boxShadow: "0 0 0 2px " + item.global_status.color };
    }

    function newOrder(){

        const ownerAddress = new Address(item.owner.address?.street,item.owner.address?.number,item.owner.address?.box,item.owner.address?.locality);

        const data = {
            pet:item.animals.map((animal)=>new Pet(animal.name,animal.species,animal.breed,null,animal.birth_date,animal.chip_id,animal.sex,animal.sterilisation_status).getJSON()),
            petOwner:new PetOwner(item.owner.first_name,item.owner.last_name,item.owner.mail,item.owner.phone,ownerAddress,item.owner.company_name,item.owner.vat).getJSON(),
        }

        navigate("/new_analysis",{state:data});
    }

    return (
        <tr className="bg-white cursor-pointer hover:bg-light-gray odd:bg-clear-green">
            <td className="text-center" onClick={() => loadReport(item.id, navigate)}>{item.is_prescriber ? <img className="size-6 m-auto" alt="" src="../iconslimsvet/owner.svg" /> : ""}</td>
            <td className="text-left" onClick={() => loadReport(item.id, navigate)}>{item.owner.first_name} {item.owner.last_name}</td>
            <td className="text-left" onClick={() => loadReport(item.id, navigate)}>{item.animals.map((animal) => <p key={animal.name}>{specieNameFromId(animal.species, species)}</p>)}</td>
            <td className="text-left" onClick={() => loadReport(item.id, navigate)}>{item.animals.map((animal) => <p key={animal.name}>{animal.name}</p>)}</td>
            <td className="text-center" onClick={() => loadReport(item.id, navigate)}><p style={style} className="max-w-24 m-auto rounded-full font-medium">{item.global_status.label}</p></td>
            <td className="text-center" onClick={() => loadReport(item.id, navigate)}>{item.accounting_status.label}</td>
            <td className="text-center" onClick={() => loadReport(item.id, navigate)}>{item.created_at}</td>
            <td className="text-center" onClick={() => loadReport(item.id, navigate)}>{item.samples_received ? <Check className="mx-auto text-[rgb(112,221,50)]" size={24}/>:<X className="mx-auto text-red" size={24}/>}</td>
            <td className="px-5 py-1 text-center">
                <ImageRoundButton className="size-8 mx-auto" color="bg-medium-green" onClick={() => navigate(`/main/modify_order?order=${item.id}`)} title="Ajout d'analyses" lucide={<ListPlus size={20} strokeWidth={2} color="white"/>} />
            </td>
            <td className="px-5 py-1 text-center">
                <ImageRoundButton className="size-8 mx-auto" color="bg-medium-green" onClick={() => newOrder()} title="Nouvelle Prescription" lucide={<ClipboardPlus size={20} strokeWidth={2} color="white"/>} />
            </td>
            <td className="px-5 py-1 text-center">
                <div className="flex gap-2 flex justify-center">
                <ImageRoundButton className="size-8" color="bg-medium-green" onClick={() => loadPurchaseOrder(item.id, navigate)} src="/iconslimsvet/purchase_order.svg" title="Prescription" />
                <ImageRoundButton className="size-8" color="bg-medium-green" onClick={() => loadReport(item.id, navigate)} src="/iconslimsvet/report.svg" title="Compte rendu" />
                </div>
            </td>
        </tr>
    );
}
function PrescriberFilter({ setOrderParam }) {

    const handleClick = (e) => {
        if (e.target.checked) {
            setOrderParam((oldParam) => {
                return (
                    {
                        ...oldParam,
                        isPrescriber: true
                    }
                )

            });
        } else {
            setOrderParam((oldParam) => {
                return (
                    {
                        ...oldParam,
                        isPrescriber: false
                    }
                )

            });
        }
    }

    return (
        <div className="flex gap-2">
            <label className="text-white" htmlFor="prescriber">Mes prescriptions: </label>
            <input className="" type="checkbox" name="prescriber" id="prescriber" onClick={handleClick} />
        </div>
    );
}
function SearchFilter({ setSearchValue }) {

    const [searchStatus, setSearchStatus] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const handleSearch = (e) => {
        setSearchValue(inputValue);
        setSearchStatus(true);
    }
    const handleDelete = (e) => {
        setInputValue("");
        setSearchValue(null);
        setSearchStatus(false);
    }

    const handleEnter = (e) => {

        if (e.key === "Enter" && e.target.value) {
            handleSearch(e);
        }
    }

    const handleChange = (e) => {
        if (e.target.value === "") {
            setSearchStatus(false);
            setSearchValue(null);
        }
        setInputValue(e.target.value);
    }

    return (
        <div className="flex flex-row gap-2">
            <label className="text-white" htmlFor="search">Recherche: </label>
            <div className="relative">
                <input value={inputValue} id="search" type="text" onKeyDown={handleEnter} onChange={handleChange}>
                </input>
                <img className="absolute cursor-pointer" alt="" src="../search.svg" style={{ height: 15, top: 3, right: 5, display: (searchStatus ? "none" : "") }} onClick={handleSearch}></img>
                <img className="absolute cursor-pointer" alt="" src="../search-cross.svg" style={{ height: 25, top: -2, right: 0, display: (searchStatus ? "" : "none") }} onClick={handleDelete}></img>
            </div>

        </div>
    )
}
function SpecieFilter({ species, setId }) {

    return (
        <div className="flex gap-2">
            <label className="text-white" htmlFor="specie">Espèces: </label>
            <select id="specie" onChange={(e) => setId(parseInt(e.target.value, 10))} defaultValue="">
                <option value="">Pas de filtre</option>
                {species.map((specie) => <option key={specie.id} value={specie.id}>{specie.label}</option>)}
            </select>
        </div>
    )
}
function StatusFilter({ navigate, setStat }) {

    const [status, setStatus] = useState([]);
    useEffect(() => { loadGlobalStatus(setStatus, navigate) }, [navigate]);

    return (
        <div className="flex gap-2">
            <label className="text-white" htmlFor="specie">Statut: </label>
            <select id="specie" onChange={(e) => setStat(parseInt(e.target.value), 10)} defaultValue="">
                <option value="">Pas de filtre</option>
                {status.map((state) => <option key={state.id} value={state.id}>{state.label}</option>)}
            </select>
        </div>
    )
}
function PageFilter({ orderParam, setOrderParam, next, previous, count }) {

    const handlePrevious = () => {
        if (previous !== null) {
            setOrderParam({
                ...orderParam,
                page: orderParam.page - 1,
            })
        }
    }
    const handleNext = () => {
        if (next !== null) {
            setOrderParam({
                ...orderParam,
                page: orderParam.page + 1,
            });
        }
    }

    return (
        <div className="flex flex-row items-center justify-center">
            <div><img className={classNames("h-5 rotate-180 cursor-pointer",(previous === null ? "opacity-0" : "opacity-100"))} alt="" src="../iconslimsvet/fleche.svg" onClick={handlePrevious}></img></div>
            <p className="text-white">{orderParam.page * orderParam.per_page - orderParam.per_page + 1}</p>
            <div><img className="h-5" src="../iconslimsvet/tiret.svg" alt=""></img></div>
            <p className="text-white">{(orderParam.page - 1) * orderParam.per_page + count}</p>
            <div><img className={classNames("h-5 cursor-pointer",(next === null ? "opacity-0" : "opacity-100"))} alt="" src="../iconslimsvet/fleche.svg" onClick={handleNext}></img></div>
        </div>
    )
}
